var _path, _path2, _path3, _circle, _circle2, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransportImg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 105,
    viewBox: "0 0 142 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78 30.5166H86.5M78 30.5166C78 30.5166 79.5275 17.5808 84.5 11.5166C90.4248 4.29109 96.6588 1.24658 106 1.01665M78 30.5166C78 30.5166 80.4972 40.8146 84.5 46.0166C90.4228 53.7138 96.3805 57.1776 106 58.5166M106 1.01665C99.1536 4.02026 95.4796 7.18754 91.5 13.5166C87.8165 19.3749 86.5 30.5166 86.5 30.5166M106 1.01665C102.773 6.01343 101.393 9.23371 100 15.0166C98.5797 20.9137 99 30.5166 99 30.5166M106 1.01665C109.955 5.79454 111.714 9.07704 113.5 15.0166C115.252 20.8403 115 30.5166 115 30.5166M106 1.01665C114.207 3.58863 118.902 7.45531 123 15.0166C125.957 20.4725 126.5 30.5166 126.5 30.5166M106 1.01665C116.563 0.707985 124.198 4.68437 130 13.5166C133.771 19.2565 134.5 30.5166 134.5 30.5166M134.5 30.5166H126.5M134.5 30.5166C134.5 30.5166 132.462 39.5384 130 44.5166C124.887 54.8534 118 58.5166 106 58.5166M106 58.5166C100.906 54.2679 98.3102 51.4463 94.5 46.0166C90.5872 40.4407 86.5 30.5166 86.5 30.5166M106 58.5166C102.747 53.5364 101.363 50.3066 100 44.5166C98.7439 39.1812 99 30.5166 99 30.5166M106 58.5166C108.877 53.3103 110.214 50.1904 112 44.5166C113.679 39.1832 115 30.5166 115 30.5166M106 58.5166C114.211 55.9592 118.915 52.0852 123 44.5166C125.676 39.5571 126.5 30.5166 126.5 30.5166M86.5 30.5166H99M99 30.5166H115M115 30.5166H126.5",
    stroke: "#005B7F",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36 77.0166V30.5166H98.5V43.5166H112.5L125 58.5166V77.0166H36Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M125.5 58.0166H98V44.2666M125.5 58.0166V77.0166H116.5M125.5 58.0166L113.5 44.2666H98M96 77.0166H71.5M50.5 77.0166H36V30.5166H53.5H98V44.2666",
    stroke: "#005B7F",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 61.5,
    cy: 79.5166,
    r: 7,
    stroke: "#005B7F",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 107.5,
    cy: 79.5166,
    r: 7,
    stroke: "#005B7F",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M71 98.5166L68 104.017C68 104.017 103.328 100.176 119 86.0166C136.677 70.0461 142 29.5166 142 29.5166C142 29.5166 130.086 65.2374 112 78.5166C93.1011 92.3929 53.5 92.0166 53.5 92.0166L71 98.5166Z",
    fill: "#FF8646"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 41.5166H55M11 53.5166H55M0 68.5166H55",
    stroke: "#FF8646",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransportImg);
export default __webpack_public_path__ + "static/media/transportIMG.c35395791b2571fc062b164aeed7cb33.svg";
export { ForwardRef as ReactComponent };